import { defineStore } from 'pinia'

export const useSubmissionWizardStore = defineStore('SubmissionWizard', {
    state: () => ({
        has_loaded_initial_data: false,

        is_mobile: null,
        company_id: null, // Populated by the layout
        submission_id: null, // Populated by the layout
        current_route_name: '',
        steps_body: [],

        navigation_steps_desktop: [],
        navigation_steps_in_order: [],

        submission: {
            category_id: null,
        },
        presentation: {
            illustrations: [],
        },
        show_gdpr_terms: "", // TODO: rename to show_gdpr_terms_and_privacy_policy
        gdpr_terms: "",
        gdpr_privacy_policy: "",
        form_type: "",

        news_privacy_policy: "",
        author_social_links: {},
        matching_editors: [],

        bottom_navigation_rules: { // Mostly maintained by the validationMixin
            can_go_next: false, // NOTE: Updated by the 'isValid()' method in each step
            mandatory_steps_complete: false,
        },

        default_cover_images: [],

        matching_taxonomies: [],
        matching_themes: [],
        has_loaded_matching_taxonomies: false,

        highlight_incomplete_steps: false,
    }),

    getters: {
        currentStepBody(state) {
            return state.steps_body[state.current_route_name];
        },

        currentStepName() {
            if (!this.current_route_name) return '';
            if (!this.steps_body[this.current_route_name]) return '';
            if (!this.steps_body[this.current_route_name]['name']) return '';

            return this.steps_body[this.current_route_name]['name'];
        },

        currentStepShortDescription() {
            // return 'This is a super nice description for this step lorem ipsum dolor sic amet and other latin words';

            if (!this.current_route_name) return '';
            if (!this.steps_body[this.current_route_name]) return '';
            if (this.form_type == 'elaborate') return ''; // We only want this return anything if the wizard type is simple.

            if (!this.steps_body[this.current_route_name]['short_description']) return '';

            return this.steps_body[this.current_route_name]['short_description'];
        }
    },

    actions: {
        executeInitialDataLoad() {
            if (this.has_loaded_initial_data) return;

            // this.loadWizardStepsBody(); // TMP Hack to ensure custom content is loaded for the wizard.
            this.loadSubmission();
            this.loadNavigation();

            this.has_loaded_initial_data = true;
        },

        loadWizardStepsBody() {
            var self = this;
            axios.get('/api/sw/submission-wizard-content/' + this.company_id + '/body?category_id=' + this.submission.category_id).then(function (response) {
                self.steps_body = response.data;
            });
        },

        loadSubmission() {
            var self = this;
            axios.get('/api/sw/submissions/' + this.submission_id).then(function (response) {
                self.allsData = response.data;
                self.submission = response.data.submission;
                self.presentation = response.data.presentation;
                self.show_gdpr_terms = response.data.show_gdpr_terms;
                self.gdpr_terms = response.data.gdpr_terms;
                self.gdpr_privacy_policy = response.data.gdpr_privacy_policy;
                self.news_privacy_policy = response.data.news_privacy_policy;
                self.author_social_links = response.data.author_social_links;
                self.form_type = response.data.form_type;

                if (self.schedule_matching_editor_loading) {
                    self.loadMatchingEditors();
                    self.schedule_matching_editor_loading = false;
                }

                self.loadWizardStepsBody(); // TMP Hack to ensure custom content is loaded for the wizard.
                self.loadNavigation();
            });
        },

        saveSubmission(isCurrentStepComplete = true) {
            var self = this;
            this.submission.current_step = this.current_route_name; // Ensures we progress the navigation
            this.submission.is_current_step_complete = isCurrentStepComplete; // TMP

            axios.patch('/api/sw/submissions/' + this.submission_id, this.submission).then(function (response) {
                self.overwriteNavigationProps(response.data.navigation);
            });
        },

        overwriteNavigationProps(navigation) {
            this.navigation_steps_desktop = navigation.desktop;
            this.navigation_steps_in_order = navigation.steps_in_order;
            this.bottom_navigation_rules.mandatory_steps_complete = navigation.mandatory_steps_complete;
        },

        // Used on the Bio step - only for the 'temp_personal_note' field.
        saveSubmissionWithoutStep() {

            axios.patch('/api/sw/submissions/' + this.submission_id, this.submission).then(function (response) {
                // Do nothing for now.
            });
        },

        saveSubmissionAndReloadWizardContent() {
            var self = this;
            this.submission.current_step = this.current_route_name; // Ensures we progress the navigation
            this.submission.is_current_step_complete = true; // TMP

            axios.patch('/api/sw/submissions/' + this.submission_id + '/update-submission-and-reload-wizard-content', this.submission).then(function (response) {
                self.overwriteNavigationProps(response.data.navigation);
                self.steps_body = response.data.steps_body;
            });
        },

        savePresentation() {
            var self = this;
            this.presentation.current_step = this.current_route_name; // Ensures we progress the navigation

            axios.patch('/api/sw/submissions/' + this.submission_id + '/presentations/' + this.presentation.id, this.presentation)
                .then(function (response) {
                    self.overwriteNavigationProps(response.data.navigation);
                })
                .catch(function (error) {
                    console.log(error);
                });

        },

        // Used on the Bio step
        savePresentationWithoutStep() {
            // var self = this;
            // this.presentation.current_step = this.current_route_name; // Ensures we progress the navigation

            axios.patch('/api/sw/submissions/' + this.submission_id + '/presentations/' + this.presentation.id, this.presentation)
                .then(function (response) {
                    // self.overwriteNavigationProps(response.data.navigation);
                })
                .catch(function (error) {
                    console.log(error);
                });

        },

        saveAuthorSocialLinks() {
            var self = this;
            axios.patch('/api/sw/author-social-links', this.author_social_links).then(function (response) {
                // Do nothing for now.
            });
        },

        loadNavigation() {
            var self = this;
            axios.get('/api/sw/submission-wizard-content/' + this.submission_id + '/navigation?current_step=' + this.current_route_name + '&category_id=' + this.submission.category_id).then(function (response) {
                self.overwriteNavigationProps(response.data);
            });
        },

        // TODO: Must trigger this after we have the submission in the store.
        loadMatchingEditors() {
            if (!(this.submission && this.submission.category_id)) {
                // console.log('Submission not yet loaded. Scheduling the Matching Editors load after it.');
                this.schedule_matching_editor_loading = true;
                return;
            }

            var self = this;
            axios.get('/api/sw/matching-editors-by-entry-and-category/' + this.submission_id).then(function (response) {
                self.matching_editors = response.data;
            });
        },

        loadDefaultCoverImages() {
            if (this.default_cover_images.length) {
                // console.log('already loaded covers. not doing it again.')
                return;
            }

            var self = this;
            axios.get('/api/images/default-cover-images').then(function (response) {
                self.default_cover_images = response.data;
            });
        },

        loadEntryPointTaxonomies() {
            var self = this;
            axios.get('/api/sw/entry-point-taxonomies/' + this.submission_id).then(function (response) {
                self.matching_taxonomies = response.data.categories;
                self.matching_themes = response.data.themes;
                self.has_loaded_matching_taxonomies = true;
            })
            .catch(function (error) {
                console.log(error);
            });
        },
    },
})
